export default __webpack_public_path__ + "static/media/asalto.e6d80b08.png";